<template lang="pug">
div
  el-card(shadow="hover").card-container
    app-divider(label="Dados do VTN: ", :addMarginTop="false").margin-bottom
    div.center.position-relative
      .info-percentual(v-if="mostrarInfo")
        span Atenção: O percentual a ser aplicado sobre o VTN é calculado automaticamente, manter vazio para ser calculado.
      el-col(:span='16')
        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Área requerida (ha):", :required="required")
          app-double-input.appInput(
            @change="setModulosFiscais"
            name='Área',
            :precision="4",
            :onkeypress="onlyInputNumbers",
            :hasValidationError="vtnRequest.areaRequerida === 0",
            v-model="vtnRequest.areaRequerida"
          )

        el-row.flexRow(v-if="isAmapa" :gutter="16")
          app-label.appLabel(label="Munícipio:", :required="required")
          div(class="appInput")
            el-select(
              v-model="vtnRequest.municipio.id"
              @change="setDados"
            )
              el-option(
                v-for="(municipio, index) in municipios"
                :key="`${index}-${municipio.id}`",
                :label="municipio.nome",
                :value="municipio.id"
              )
        el-row.flexRow(v-else :gutter="16")
          app-label.appLabel(label="Munícipio:", :required="required")
          div(class="el-input-group el-input-group--prepend appInput")
            el-input(
              v-model="vtnRequest.municipio.nome",
              :disabled="disable"
            )

        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Número de Módulos fiscais:", :required="required")
          app-double-input.appInput(
            name='Número de Módulos fiscais',
            :precision="4",
            v-model="vtnRequest.nModuloFiscal",
            :onkeypress="onlyInputNumbers",
            :disable="disable"
          )

      el-col(:span='16')
        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Módulo Fiscal do Múnicípio - MF (ha):", :required="required")
          app-double-input.appInput(
            name='Módulo Fiscal do Múnicípio',
            :precision="2",
            :onkeypress="onlyInputNumbers",
            :disable="disable",
            v-model="vtnRequest.moduloFiscal"
          )

        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Valor mínimo da Pauta de VTN (PVTN):", :required="required")
          app-double-input.appInput(
            v-if="vtnRequest.pvtn && vtnRequest.pvtn.vtnPorHaMin"
            name='Valor mínimo da Pauta de VTN',
            :precision="2",
            prefix='R$ '
            :onkeypress="onlyInputNumbers",
            :disable="disable",
            v-model="vtnRequest.pvtn.vtnPorHaMinFormatado"
          )
        el-row.flexRow(:gutter="16")
          div.appLabel.flexRow
            app-label(label="Percentual a ser aplicado sobre o VTN: ", :required="false")
            div(@mouseover="mostrarInfo = true", @mouseleave="mostrarInfo = false").mr-5
              i.fa.fa-info-circle
          app-double-input.appInput(
            name='Percentual a ser aplicado sobre o VTN',
            :hasValidationError="vtnRequest.percentualCalculado > 100",
            :precision="2",
            :onkeypress="onlyInputNumbers",
            :hasLimitValue="6"
            v-model="vtnRequest.percentualCalculado"
          )
</template>

<script>
import { mapActions } from 'vuex'
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import AppLabel from '@/components/AppLabel'
import AppDoubleInput from '@/components/AppDoubleInput'
import AppDivider from '@/components/AppDivider.vue'
import AppDisplay from '@/components/AppDisplay'
export default {
  mixins: [onlyInputNumbers],
  components: {
    AppDivider,
    AppDisplay,
    AppLabel,
    AppDoubleInput
  },

  props: {
    required: {
      type: Boolean,
      default: true
    },

    vtnRequest: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      input: '',
      disable: true,
      temMunicipio: false,
      mostrarInfo: false,
      municipios: []
    }
  },

  async mounted () {
    if (this.isAmapa) {
      this.municipios = await this.findMunicipiosByUf('AP')
    }
  },

  computed: {
    isAmapa () {
      return process.env.ESTADO === 'ap'
    }
  },
  actions: {
    async setMunicipio ({ commit, state }, idMunicipio) {
      const municipio = state.municipios.find(m => m.id === idMunicipio)
      commit('SET_MUNICIPIO', municipio)
    }
  },
  mutations: {
    SET_MUNICIPIO (state, municipio) {
      state.vtnRequest.municipio = municipio
    }
  },

  methods: {
    ...mapActions({
      findMunicipiosByUf: 'municipios/findMunicipiosByUf'
    }),
    setModulosFiscais () {
      this.vtnRequest.nModuloFiscal = this.vtnRequest.areaRequerida / this.vtnRequest.moduloFiscal
      if (this.vtnRequest.nModuloFiscal <= 4 && this.vtnRequest.moduloFiscal === 50) {
        this.vtnRequest.coeficienteAngular = 0.133333422
        this.vtnRequest.coeficienteLinear = 3.333315556
      } else if (this.vtnRequest.nModuloFiscal <= 4 && this.vtnRequest.moduloFiscal === 70) {
        this.vtnRequest.coeficienteAngular = 0.095238141
        this.vtnRequest.coeficienteLinear = 3.333320635
      } else if (this.vtnRequest.nModuloFiscal >= 4 && this.vtnRequest.areaRequerida <= 2500 && this.vtnRequest.moduloFiscal === 50) {
        this.vtnRequest.coeficienteAngular = 0.008695653
        this.vtnRequest.coeficienteLinear = 28.26086862
      } else if (this.vtnRequest.nModuloFiscal >= 4 && this.vtnRequest.areaRequerida <= 2500 && this.vtnRequest.moduloFiscal === 70) {
        this.vtnRequest.coeficienteAngular = 0.009009009
        this.vtnRequest.coeficienteLinear = 27.47747646
      }
    },

    calcularPercentual (coeficienteAngular, area, coeficienteLinear) {
      return (coeficienteAngular * area) + coeficienteLinear
    },

    calcularValorFinalImovel (percentual, valorMinimo, area) {
      return ((percentual / 100) * valorMinimo) * area
    },

    calculaModuloFiscalPorMunicipio (value) {
      this.$emit('calculaModuloFiscal', value)
    },
    setDados (idMunicipio) {
      this.$emit('setDados', {municipio: this.municipios.find(m => m.id === idMunicipio), areaRequerida: this.vtnRequest.areaRequerida})
    }

  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/element-variables.scss";

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.margin-bottom {
  margin-bottom: 20px;
}

.center {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 7%;
}
.flex {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: inherit;
}

.el-row {
  margin-bottom: 20px;
}

.flexRow {
  display: flex;
}

.appLabel {
  flex: 1;
}

.appInput {
  flex: 0.5;

  >>> .el-input__inner {
    border-radius: 4px !important;
  }
}

.el-input__inner {
  border-radius: 4px;
  font-size: 14px;
}

.el-input-group__append {
  color: $--color-text-regular
}
.info-percentual {
  background-color: #f0f8ff;
  border-left: 5px solid #007bff;
  padding: 10px 15px;
  margin: 10px 0;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  font-family: Arial, sans-serif;
  color: #333;
  font-size: 16px;
  position: absolute;
  z-index: 1000;
  top: 40%;
  width: 300px;
  left: 45%;
}

.info-percentual span {
  margin-bottom: 0;
}
.position-relative {
  position: relative;
}
.mr-5 {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/components/InformarDados.vue